import { Component, OnInit } from '@angular/core';
import { BadeLoftService } from '../bade-loft.service';
import { environment } from 'src/environments/environment';
import { ResponseMessageStatus, ResponseStatus } from 'src/app/shared/enums';
import { CommonService } from 'src/app/services/common.service';
import { HttpClient } from '@angular/common/http';
@Component({
  selector: 'app-connection-status',
  templateUrl: './connection-status.component.html',
  styleUrls: ['./connection-status.component.css'],
})
export class ConnectionStatusComponent implements OnInit {
  //#region properties
  appClientId: any = environment.appclientId;
  redirectUrl: any = environment.redirectURL;
  authDetails: any;
  isFetchingAuthDetails: boolean = true;
  isDisconnecting: boolean = false;
  isTestingConnection: boolean = false;
  fileURL: any;
  isRestartingService: boolean = false;
  services: any[] = [
    {
      id: 1,
      title: 'Shipping Document Service',
      status: 'Running',
      isLoading: false,
    },
    {
      id: 2,
      title: 'Quickbooks Customer To Zoho Contact/Lead convert',
      status: 'Running',
      isLoading: false,
    },
    {
      id: 3,
      title: 'Woocomerce Order To Quickbooks Invoice',
      status: 'Running',
      isLoading: false,
    },
    {
      id: 4,
      title: 'After Ship To Zoho note',
      status: 'Running',
      isLoading: false,
    },
    {
      id: 5,
      title: 'Zoho Webhook Service',
      status: 'Running',
      isLoading: false,
    },
  ];
  //constructor
  constructor(
    private _blS: BadeLoftService,
    public _cS: CommonService,
    private http: HttpClient
  ) {}

  //#region functions
  ngOnInit(): void {
    // this.getAuthDetails();
    this.QBOAuthConnectionTest();
    //TODO: Check Connection exists  on api ?
    // api/QBOConnection/GetQBOAuthDetail
    // if connection detail found show on page.
    // connect exists than show
    // if connection not found show Quickboks Button.

    this.checkServiceStatus(1);
    this.checkServiceStatus(2);
    this.checkServiceStatus(3);
    this.checkServiceStatus(4);
    this.checkServiceStatus(5);

    this.http
      .get('../assets/images/TroubleShoot Intructions.pdf', {
        responseType: 'blob',
      })
      .subscribe((res) => {
        const reader = new FileReader();
        reader.onloadend = () => {
          var base64data: any = reader.result;
          var data = base64data.split(',')[1];
          const byteArray = new Uint8Array(
            atob(data)
              .split('')
              .map((char) => char.charCodeAt(0))
          );
          const file = new Blob([byteArray], { type: 'application/pdf' });
          this.fileURL = URL.createObjectURL(file);
        };

        reader.readAsDataURL(res);
      });
  }

  //connect to QBO
  QBOAuthConnectionTest(test?: any) {
    this.isTestingConnection = true;
    this._blS.QBOAuthConnectionTest().subscribe((response: any) => {
      if (response.responseStatus == ResponseStatus.Success) {
        this.isTestingConnection = false;
        if (test) {
          this._cS.displayMessage(
            ResponseMessageStatus.success,
            response.message
          );
        }
        if (!test) {
          this.isFetchingAuthDetails = true;
          this.getAuthDetails();
        }
      } else {
        this.authDetails = null;
        this.isTestingConnection = false;
        // this._cS.displayMessage(
        //   ResponseMessageStatus.success,
        //   response.message
        // );
        this.isFetchingAuthDetails = false;
      }
    });
  }
  getAuthDetails() {
    try {
      //once response from server as one url that url you need to open in browser same window.
      this._blS.GetQBOAuthDetail().subscribe((response: any) => {
        if (response.responseStatus == ResponseStatus.Success) {
          this.authDetails = response.result;
          this.isFetchingAuthDetails = false;
        } else {
          this.isFetchingAuthDetails = false;
        }
      });
    } catch (error) {}
  }
  getLocalDateTime(date: any) {
    if (date) {
      var NewDate_ = date.replace('Z', '');
      NewDate_ = NewDate_.replace('T', ' ');
      return NewDate_;
    }
  }
  testConnection(test: any) {
    this.QBOAuthConnectionTest('test');
  }
  disconnectFromQBO() {
    try {
      this.isDisconnecting = true;
      //once response from server as one url that url you need to open in browser same window.
      this._blS.revokeQBOAuthConnectionTest().subscribe((response: any) => {
        if (response == true) {
          this.authDetails = null;
          this.isDisconnecting = false;
        } else {
          this.isDisconnecting = false;
        }
      });
    } catch (error) {}
  }
  checkServiceStatus(id: any) {
    this.services[id - 1].isLoading = true;
    this._blS.checkServiceStatus(id).subscribe((response: any) => {
      this.services[id - 1].isLoading = false;
      if (response) {
        if (response.result == true) {
          this.services[id - 1].status = 'Running';
        } else {
          this.services[id - 1].status = 'Stopped';
        }
        this.services = [...this.services];
      }
    });
  }
  restartService(id: any) {
    this.isRestartingService = true;
    this._blS.startWindowService().subscribe((response: any) => {
      this.isRestartingService = false;
      this._cS.displayMessage('', response);
    });
  }
  openTroubleShootDoc() {
    window.open(this.fileURL, '_blank');
  }
}
